import ScrollableContainer from "@/ui/scrollable-container/scrollable-container";
import { withCategories } from "@/api/categories";

import { Category } from "./category";

import styles from "./categories.module.css";

export const Categories = withCategories(({ categories }) => {
  return (
    <ScrollableContainer>
      <div className={styles.categoriesWrapper}>
        {categories.map((category) => (
          <Category key={category.id} category={category} />
        ))}
      </div>
    </ScrollableContainer>
  );
});
